export default __webpack_public_path__ + "static/media/excess_irrigation.4568bd0b.png";